<script setup>
import { computed } from 'vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

const displayName = computed(() => {
  const name = props.inbox?.name || '';
  return name
    .replace(/^\s*\[ARQUIVADA\]\s*/i, '')
    .replace(/^\s*arquivada\s*[-:]\s*/i, '')
    .replace(/\s·\s[a-f0-9]+$/i, '');
});
</script>

<template>
  <div :title="displayName" class="flex items-center min-w-0">
    <span class="truncate text-label-small text-n-slate-11">
      {{ displayName }}
    </span>
  </div>
</template>
